import {Component, Inject, Optional} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SharedModule} from "../../shared/modules/shared-module.module";
import {
    ExportComponentConfig,
    ExportComponentDataConfig
} from "../component-events-table-form/component-events-table-form.component";
import {HttpClient} from "@angular/common/http";
import {catchError, take} from "rxjs/operators";
import {of} from "rxjs";
import {COMPONENT_EVENTS_CONFIG} from "../../_typing/config/component-events-table";

@Component({
    selector: 'export-component-dialog',
    imports:[SharedModule],
    templateUrl: './export-component-dialog.component.html',
    styleUrls: ['./export-component-dialog.component.scss']
})
export class ExportComponentDialogComponent {

    action: string;
    exportConfig: ExportComponentConfig;
    supportedExportHandlers: string[];
    supportedExporterTypes: string[] = ['JDE', 'SAP', 'PRONTO'];

    config: Partial<COMPONENT_EVENTS_CONFIG>;

    constructor(private http: HttpClient,
                public dialogRef: MatDialogRef<ExportComponentDialogComponent>,
                // @Optional() is used to prevent error if no data is passed
                @Optional() @Inject(MAT_DIALOG_DATA) public data: ExportComponentDataConfig
    ) {
        this.exportConfig = data.exportComponentConfig;
        this.action = data.action;

        this.http.get('/api/exporters').pipe(take(1),
            catchError(e => {
                console.log(e);
                return of([])
            })).subscribe((data:string[]) => {
            this.supportedExporterTypes = data;
        });
    }

    onChangeBulkExport(event: any) {
        this.exportConfig.supports_bulk_export = event.checked;
    }

    onExportTypeSelected(event) {
        this.http.get('/api/export_options', {
            params: {
                exporter_name: event.value
            }
        }).pipe(take(1),
            catchError(e => {
                console.log("ERROR: ComponentEventsTableForm (export_options), error getting supported data", e);
                this.supportedExportHandlers = [];
                return of([])
            })).subscribe((data: string[]) => {
            this.supportedExportHandlers = data;
        });
    }

    onChangeRowExport(event: any) {
        this.exportConfig.supports_row_export = event;
    }

    doAction() {
        this.dialogRef.close({event: this.action, data: this.exportConfig});
    }

    closeDialog() {
        this.dialogRef.close({event: 'Cancel'});
    }

}
